import * as R from 'ramda'
import { initialState } from './initialState'
import { uiActionTypes } from '../actions'
import { createReducer } from '@mattilsynet/redux-common'

// Types
import { IUiState } from '../types'
import { IConfigInterface, IOidcConfig } from '../../../config.d'

// lenses
import { reducerLenses } from '../selectors'

export const STORE_NAME = 'ui'

const uiReducer = createReducer(initialState, {
  [uiActionTypes.ACCESS_DENIED]: (state: IUiState): IUiState =>
    R.set(
      reducerLenses.initializationStatus(),
      {
        loading: false,
        error: null,
        loaded: true,
      },
      state,
    ),

  [uiActionTypes.CONFIG_LOADED]: (
    state: IUiState,
    { payload }: { payload: IConfigInterface },
  ): IUiState => R.mergeRight(state, { ...payload }),

  [uiActionTypes.SET_PAGE_TITLE]: (
    state: IUiState,
    { title }: { title: string },
  ): IUiState => R.mergeRight(state, { title }),

  [uiActionTypes.SET_OIDC_CONFIG]: (
    state: IUiState,
    { oidcConfig }: { oidcConfig: IOidcConfig },
  ): IUiState => R.mergeRight(state, { oidcConfig }),

  [uiActionTypes.INITIALIZE]: (state: IUiState): IUiState =>
    R.set(
      reducerLenses.initializationStatus(),
      {
        loading: true,
        error: null,
        loaded: false,
      },
      state,
    ),

  [uiActionTypes.INITIALIZE_SUCCESS]: (state: IUiState): IUiState =>
    R.set(
      reducerLenses.initializationStatus(),
      {
        loading: false,
        error: null,
        loaded: true,
      },
      state,
    ),

  [uiActionTypes.INITIALIZE_FAILED]: (state: IUiState, { error }): IUiState =>
    R.set(
      reducerLenses.initializationStatus(),
      {
        loading: false,
        error: error,
        loaded: false,
      },
      state,
    ),
})

export default {
  [STORE_NAME]: uiReducer,
}
